import type { TError, TVideoWatchCounts } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Query key for fetching the user's video watch counts of a lesson - non-hook version
 */
export const getVideoWatchCountsQueryKey = (lessonId: string) => [ENTITY, 'video-watch-counts', lessonId];

/**
 * Query key for fetching the user's video watch counts of a lesson
 */
export const useGetVideoWatchCountsQueryKey = (lessonId: string) => getVideoWatchCountsQueryKey(lessonId);

/**
 * Hook to fetch how many times the current user has watched each video block
 * of a lesson. Returns a map of content block ID -> play count.
 *
 * @param lessonId - Lesson ID (UUID)
 * @param enabled - Set false to skip the fetch (e.g. watch count UI is hidden)
 */
export const useGetVideoWatchCounts = (lessonId: string, enabled = true) => {
  return useQuery<TVideoWatchCounts, TError>({
    queryKey: useGetVideoWatchCountsQueryKey(lessonId),
    queryFn: async () => {
      const res = await axios.get<TVideoWatchCounts>(`/community-hub/lessons/${lessonId}/video-watch-counts`);
      return res.data;
    },
    enabled: !!lessonId && enabled,
    staleTime: 60 * 1000, // 1 minute (counts move as the user watches)
  });
};
